// src/utils/timezones.js
export const timezones = [
  { value: 'GMT-12', label: '(GMT-12:00) International Date Line West' },
  { value: 'GMT-11', label: '(GMT-11:00) Midway Island, Samoa' },
  { value: 'GMT-10', label: '(GMT-10:00) Hawaii' },
  { value: 'GMT-09', label: '(GMT-09:00) Alaska' },
  { value: 'GMT-08', label: '(GMT-08:00) Pacific Time (US & Canada)' },
  { value: 'GMT-07', label: '(GMT-07:00) Mountain Time (US & Canada)' },
  { value: 'GMT-06', label: '(GMT-06:00) Central Time (US & Canada)' },
  { value: 'GMT-05', label: '(GMT-05:00) Eastern Time (US & Canada)' },
  { value: 'GMT-04', label: '(GMT-04:00) Atlantic Time (Canada)' },
  { value: 'GMT-03:30', label: '(GMT-03:30) Newfoundland' },
  { value: 'GMT-03', label: '(GMT-03:00) Buenos Aires, Greenland' },
  { value: 'GMT-02', label: '(GMT-02:00) Mid-Atlantic' },
  { value: 'GMT-01', label: '(GMT-01:00) Azores, Cape Verde Is.' },
  { value: 'GMT', label: '(GMT+00:00) London, Lisbon, Casablanca' },
  { value: 'GMT+01', label: '(GMT+01:00) Central European Time (Berlin, Paris, Rome)' },
  { value: 'GMT+02', label: '(GMT+02:00) Eastern European Time (Athens, Cairo, Jerusalem)' },
  { value: 'GMT+03', label: '(GMT+03:00) Moscow, St. Petersburg, Eastern Africa' },
  { value: 'GMT+03:30', label: '(GMT+03:30) Tehran' },
  { value: 'GMT+04', label: '(GMT+04:00) Abu Dhabi, Muscat' },
  { value: 'GMT+04:30', label: '(GMT+04:30) Kabul' },
  { value: 'GMT+05', label: '(GMT+05:00) Islamabad, Karachi' },
  { value: 'GMT+05:30', label: '(GMT+05:30) India Standard Time (Mumbai, Kolkata, New Delhi)' },
  { value: 'GMT+05:45', label: '(GMT+05:45) Kathmandu' },
  { value: 'GMT+06', label: '(GMT+06:00) Almaty, Dhaka' },
  { value: 'GMT+06:30', label: '(GMT+06:30) Yangon (Rangoon)' },
  { value: 'GMT+07', label: '(GMT+07:00) Bangkok, Jakarta, Hanoi' },
  { value: 'GMT+08', label: '(GMT+08:00) Beijing, Hong Kong, Singapore' },
  { value: 'GMT+09', label: '(GMT+09:00) Tokyo, Seoul, Osaka' },
  { value: 'GMT+09:30', label: '(GMT+09:30) Adelaide, Darwin' },
  { value: 'GMT+10', label: '(GMT+10:00) Eastern Australia (Sydney, Melbourne)' },
  { value: 'GMT+11', label: '(GMT+11:00) Solomon Islands, New Caledonia' },
  { value: 'GMT+12', label: '(GMT+12:00) Auckland, Wellington, Fiji, Kamchatka' },
  { value: 'GMT+13', label: '(GMT+13:00) Nuku\'alofa, Samoa' },
  { value: 'GMT+14', label: '(GMT+14:00) Kiritimati' }
];